import React from 'react';

import useIsMinBreakpoint from '@hero/react-hooks/mediaQuery/useIsMinBreakpoint';
import { useFormContext } from '@hero/ui-kit/inputs/Form';
import Input from '@hero/ui-kit/inputs/Input';
import Container from '@hero/ui-kit/layout/Container';
import Section from '@hero/ui-kit/layout/Section';
import P from '@hero/ui-kit/typography/P';
import DeviceInfo from '../DeviceInfo';

interface ExistingHeroUserFormFieldsProps {
    showAdminEmailError?: boolean;
    showHeroSerialErrorError?: boolean;
    canEdit?: boolean;
}

const ExistingHeroUserFormFields: React.FC<ExistingHeroUserFormFieldsProps> = ({
    showAdminEmailError = false,
    showHeroSerialErrorError = false,
    canEdit = true
}) => {
    const isMinL = useIsMinBreakpoint('l');

    const { setFocus } = useFormContext();

    const disabled = !canEdit;

    React.useEffect(() => {
        if (showAdminEmailError) {
            setFocus('admin_email');
        }

        if (showHeroSerialErrorError) {
            setFocus('external_serial');
        }
    }, [showAdminEmailError, showHeroSerialErrorError, setFocus]);

    return (
        <Section
            styles={{ background: '#F7F7F7' }}
            paddingHorizontal="regular"
            paddingTop="regular"
        >
            <DeviceInfo />
            <Container
                gridTemplateColumns={isMinL ? '1fr 1fr' : '1fr'}
                gridColumnGap="regular"
                gridRowGap="small"
            >
                <div>
                    <Input
                        name="admin_email"
                        displayName="Hero Admin Email"
                        isError={showAdminEmailError}
                        styles={{ ...(showAdminEmailError && { marginBottom: '1.2rem' }) }}
                        disabled={disabled}
                    />
                    {showAdminEmailError ? <P size="small">Email not found</P> : null}
                </div>
                <div>
                    <Input
                        name="external_serial"
                        displayName="Hero Serial Number"
                        isError={showHeroSerialErrorError}
                        styles={{ ...(showHeroSerialErrorError && { marginBottom: '1.2rem' }) }}
                        disabled={disabled}
                    />
                    {showHeroSerialErrorError ? (
                        <P size="small">Hero serial number not found</P>
                    ) : null}
                </div>
            </Container>
        </Section>
    );
};

export default ExistingHeroUserFormFields;
